import {
  MEDIA_LIBRARY_MODALS,
  MEDIA_LIBRARY_URL,
  MEDIA_TABLE_FILTER_TAG,
  MEDIA_TABLE_FILTER_TYPE,
  MODAL_CREATE_CONTENT_GROUP,
  MODAL_CREATE_FOLDER,
  MODAL_MOVE_TO_FOLDER,
} from "fleet/constant/media-library";
import { ConnectedContentGroupModal } from "fleet/controller/media-library/connected-content-group-modal";
import { ConnectedFolderCreateForm } from "fleet/controller/media-library/connected-folder-create-form";
import { ConnectedMediaTable } from "fleet/controller/media-library/connected-media-table";
import { ConnectedMediaUploadButton } from "fleet/controller/media-library/connected-media-upload-button";
import PropTypes from "prop-types";
import React from "react";
import {
  Breadcrumb,
  Button,
  Col,
  Modal,
  ProgressBar,
  Row,
} from "react-bootstrap";
import { Link, Redirect } from "react-router-dom";
import { makeGetAllAsArray } from "redux-store";
import BackButton from "ui/button/back";
import Box from "view/layout/box";
import Page from "view/layout/page";

import { MediaFolderModal } from "./folder-modal";
import { getFolderUrl, isContentFolder } from "./utils";

const getAllFoldersAsArray = makeGetAllAsArray();

class MediaList extends React.Component {
  static get displayName() {
    return "MediaList";
  }

  static get propTypes() {
    return {
      archive: PropTypes.func,
      closeModal: PropTypes.func,
      folder: PropTypes.object,
      folders: PropTypes.object,
      isUploading: PropTypes.bool,
      mediaTypes: PropTypes.array,
      moveToFolder: PropTypes.func,
      onError: PropTypes.func,
      openModal: PropTypes.func,
      title: PropTypes.string,
      redirect: PropTypes.func,
      redirectTo: PropTypes.shape({
        folderId: PropTypes.number,
        shouldRedirect: PropTypes.bool,
      }),
      showSidebar: PropTypes.func,
      selected: PropTypes.array,
      selectMedia: PropTypes.func,
      visibleModal: PropTypes.oneOf(MEDIA_LIBRARY_MODALS),
    };
  }

  static get defaultProps() {
    return {
      archive: () => {},
      closeModal: () => {},
      folders: {},
      isUploading: false,
      mediaTypes: [],
      moveToFolder: () => {},
      onError: () => {},
      openModal: () => {},
      title: "",
      redirect: () => {},
      redirectTo: {
        folderId: null,
        shouldRedirect: false,
      },
      selected: [],
      selectMedia: () => {},
    };
  }

  constructor(props) {
    super(props);

    this.filterTableData = this.filterTableData.bind(this);
    this.onArchive = this.onArchive.bind(this);
    this.onMoveToFolder = this.onMoveToFolder.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onSelectAll = this.onSelectAll.bind(this);
    this._getSelectedOrError = this._getSelectedOrError.bind(this);
    this._renderActions = this._renderActions.bind(this);
    this._renderTitleBar = this._renderTitleBar.bind(this);

    const { openModal } = this.props;
    this.openMoveToFolderModal = () => openModal(MODAL_MOVE_TO_FOLDER);
    this.openCreateFolderModal = () => openModal(MODAL_CREATE_FOLDER);
    this.openCreateContentGroupModal = () => {
      openModal(MODAL_CREATE_CONTENT_GROUP);
    };

    this.filterFields = [MEDIA_TABLE_FILTER_TAG, MEDIA_TABLE_FILTER_TYPE];

    this.selectOpts = {
      mode: "checkbox",
      onSelect: this.onSelect,
      onSelectAll: this.onSelectAll,
    };

    this.formatOpts = {
      name: this._formatName,
    };

    this.tableOpts = {
      onRowClick: this.onRowClick,
    };
  }

  onRowClick(row) {
    if (isContentFolder(row.type)) {
      this.props.redirect(row.id);
      return;
    }
    this.props.showSidebar(row);
  }

  onSelect(media) {
    const { selectMedia, selected: curSelected } = this.props;
    const selected = curSelected.slice();

    const sIdx = curSelected.findIndex((m) => {
      return m.id === media.id && m.type === media.type;
    });

    if (sIdx >= 0) {
      selected.splice(sIdx, 1);
    } else {
      selected.push(media);
    }

    selectMedia(selected);
  }

  onSelectAll(isSelected, rows) {
    let selected = [];
    if (isSelected) {
      selected = rows;
    }
    this.props.selectMedia(selected);
  }

  onArchive() {
    const selected = this._getSelectedOrError();
    if (!selected) {
      return;
    }

    this.props.archive(selected);
  }

  onMoveToFolder(folderId) {
    const selected = this._getSelectedOrError();
    if (!selected) {
      return;
    }

    const { onError, moveToFolder, closeModal } = this.props;
    const mediaToMove = selected.filter((m) => !isContentFolder(m.type));
    if (mediaToMove.length !== selected.length) {
      onError("Error: Cannot move folders to folder.");
      closeModal();
      return;
    }

    moveToFolder(folderId, mediaToMove);
  }

  filterTableData(data) {
    const { folder } = this.props;
    const folderId = folder ? folder.id : null;
    return this._filterByFolderId(folderId, data);
  }

  _filterByFolderId(folderId, data) {
    return data.filter((item) => {
      return item.folderId === folderId && item.archived === false;
    });
  }

  _getSelectedOrError() {
    const { onError, selected } = this.props;
    if (selected && selected.length) {
      return selected;
    }

    onError("Please select one or more media");
    return null;
  }

  _formatName(_, mediaEntry) {
    const { type, id, name } = mediaEntry;
    if (isContentFolder(type)) {
      return (
        <Link to={getFolderUrl(id)} className="media-folder-link">
          {name}
        </Link>
      );
    }
    return name;
  }

  _renderBreadcrumbs(folder) {
    if (!folder) {
      return null;
    }
    return (
      <Breadcrumb>
        <Breadcrumb.Item href={MEDIA_LIBRARY_URL}>
          Media Library
        </Breadcrumb.Item>
        <Breadcrumb.Item active>{folder.name}</Breadcrumb.Item>
      </Breadcrumb>
    );
  }

  _renderTitleBar() {
    const { folder, title, onError } = this.props;
    return (
      <Row>
        <Col xs={7}>
          <h1 className="media-list-title">{title}</h1>
        </Col>
        <Col xs={5} className="button-spacing text-right">
          <ConnectedMediaUploadButton
            key="upload-button"
            folderId={folder ? folder.id : null}
            onError={onError}
          />
          <Button
            onClick={this.openCreateContentGroupModal}
            variant="secondary"
          >
            Create Media Group
          </Button>
          {!folder && (
            <Button
              key="create-folder-btn"
              onClick={this.openCreateFolderModal}
              variant="secondary"
            >
              Create Folder
            </Button>
          )}
        </Col>
      </Row>
    );
  }

  _renderActions() {
    return (
      <div id="media-list-actions" className="button-spacing">
        <Button key="archive" onClick={this.onArchive} variant="secondary">
          Archive
        </Button>
        <Button
          key="move-to-folder"
          onClick={this.openMoveToFolderModal}
          variant="secondary"
        >
          Move to Folder
        </Button>
      </div>
    );
  }

  _renderRedirect(redirectTo, visibleModal = null) {
    const { folderId, shouldRedirect } = redirectTo;

    // Don't redirect if there's a modal open. This allows us to create
    // folders from the move folder modal and not redirect prematurely
    if (!shouldRedirect || visibleModal) {
      return null;
    }

    const url = folderId ? getFolderUrl(folderId) : MEDIA_LIBRARY_URL;
    return <Redirect to={url} />;
  }

  _renderModals() {
    const { onMoveToFolder } = this;
    const { closeModal, folder, folders, visibleModal } = this.props;

    const foldersAsArray = getAllFoldersAsArray(folders);

    const renderedModals = [
      <MediaFolderModal
        key={MODAL_MOVE_TO_FOLDER}
        folder={folder}
        isVisible={visibleModal === MODAL_MOVE_TO_FOLDER}
        folders={foldersAsArray}
        onClose={closeModal}
        onMove={onMoveToFolder}
      />,
      <ConnectedContentGroupModal
        key={MODAL_CREATE_CONTENT_GROUP}
        isVisible={visibleModal === MODAL_CREATE_CONTENT_GROUP}
        onCancel={closeModal}
      />,
    ];

    if (folder) {
      return renderedModals;
    }

    renderedModals.push(
      <Modal
        key={MODAL_CREATE_FOLDER}
        size="sm"
        show={visibleModal === MODAL_CREATE_FOLDER}
      >
        <Modal.Header>
          <Modal.Title>Create Folder</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ConnectedFolderCreateForm onCancel={closeModal} />
        </Modal.Body>
      </Modal>,
    );
    return renderedModals;
  }

  render() {
    const { folder, isUploading, mediaTypes, redirectTo, visibleModal } =
      this.props;

    return (
      <Page
        breadcrumbs={this._renderBreadcrumbs(folder)}
        toolbox={this._renderTitleBar()}
      >
        {this._renderRedirect(redirectTo, visibleModal)}
        {this._renderModals()}
        <Box noHeader={true}>
          {isUploading && !visibleModal && (
            <ProgressBar
              active="true"
              variant="success"
              now={100}
              label="Uploading..."
            />
          )}
          <ConnectedMediaTable
            actions={this._renderActions()}
            clickable={true}
            includeMediaTypes={mediaTypes}
            filterFields={this.filterFields}
            formatters={this.formatOpts}
            getRef={this._setTableRef}
            options={this.tableOpts}
            processTableData={this.filterTableData}
            selectOptions={this.selectOpts}
            toolbarWidth={12}
          />
          {folder && <BackButton />}
        </Box>
      </Page>
    );
  }
}

export { MediaList };
